import {useCallback} from 'react';
import {useModal} from 'extensions/viewport/useModal';
import {ModalBulkDownload} from 'interface/stacks/ModalBulkDownload';

export function useModalBulkDownload(ids: string[]) {
  const modal = useModal();
  const open = useCallback(() => {
    modal.open(
      <ModalBulkDownload {...{ids, exit: modal.exit}}/>
    );
  }, [ids]);
  return {open, exit: modal.exit};
}
